module.exports = __webpack_public_path__ + "img/logo-validateiq-pink.594076a5.png";